import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PaginationControlsDirective, PaginationInstance } from 'ngx-pagination';

@Component({
  selector: 'app-custom-pagination',
  templateUrl: './custom-pagination.component.html'
})
export class CustomPaginationComponent implements OnChanges {
  @Input() config: PaginationInstance;
  @Output() configChange: EventEmitter<PaginationInstance> = new EventEmitter();
  @Input() prevIconSrc: string;
  @Input() nextIconSrc: string;
  @Input() circle: boolean;
  @Input() showPerPageNumber?: boolean = false;
  @Input() itemsPerPage = [
    5,
    10,
    15
  ];

  public innerWidth: number;
  public visiblePages: any[];
  public openDropDown = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.config) {
      this.config = changes.config.currentValue;
      this.updateVisiblePages();
    }
  }

  ngOnInit() {
    this.updateVisiblePages();
  }

  public setCurrentPage(pageNumber): void {
    this.config.currentPage = pageNumber;
    this.configChange.emit(this.config);
    this.updateVisiblePages();
  }

  public setPerPage(itemsCount): void {
     this.config.currentPage = 1;
    this.config.itemsPerPage = itemsCount;
    this.configChange.emit(this.config);
    this.updateVisiblePages();
  }

  public previousPage(isFirstPage): void {
    if (!isFirstPage) {
      this.setCurrentPage(--this.config.currentPage);
    }
  }

  public nextPage(lastPage): void {
    if (!lastPage) {
      this.setCurrentPage(++this.config.currentPage);
    }
  }

  private updateVisiblePages() {
    const totalPages = Math.ceil(this.config.totalItems / this.config.itemsPerPage);
    const current = this.config.currentPage;
    let maxVisible = window.innerWidth < 640 ? 2 : 5;
    const pages: number[] = Array.from({ length: totalPages }, (_, i) => i + 1);

    if (totalPages <= maxVisible) {
      this.visiblePages = pages;
      return;
    }

    const half = Math.floor(maxVisible / 2);
    let start = Math.max(current - half, 1);
    let end = Math.min(start + maxVisible - 1, totalPages);

    if (end === totalPages) start = totalPages - maxVisible + 1;
    this.visiblePages = [];

    // Add main visible pages
    this.visiblePages.push(...pages.slice(start - 1, end));

    // Always include last page
    if (end < totalPages) {
      if (end < totalPages - 1) this.visiblePages.push('...');
      this.visiblePages.push(totalPages);
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.innerWidth = window.innerWidth;
    this.updateVisiblePages();
  }
}
